import * as React from 'react'
import { PegasusLoader } from '../pegasus-loader'

import type { PegasusLoaderProps } from '../pegasus-loader'

export type ClearSpinnerProps = PegasusLoaderProps

export const ClearSpinner = React.forwardRef<SVGSVGElement, ClearSpinnerProps>(
  function ClearSpinner(props, ref) {
    return <PegasusLoader ref={ref} {...props} />
  },
)
